import React, { useCallback, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Spinner, Modal, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useTimer } from "react-timer-hook";
import {
  getPracticeQuestions,
  submitAnswer,
} from "../../../store/actions/studentAction/assessmentActions";
import "./css/assessment.css";
import StartExam from "./StartExam";
import MyTimer from "../../Timer";
const Assessment = (props) => {
  const { id, sem } = useParams();
  const { student } = useSelector((state) => state);
  const { studentAuth } = student;
  const { profile } = studentAuth;
  const [subjectId, setSubjectid] = useState("");
  const [arr, setArr] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const [agree, setAgree] = useState(false);
  const [show, setShow] = useState(false);

  const [answerId, setAnswerid] = useState("");

  // const [data, setData] = useState({});

  const confirm = useCallback(() => {
    setAgree(true);
  }, [agree]);
  const [questions, setQuestions] = useState(null);
  const fetch = async (id) => {
    const response = await dispatch(getPracticeQuestions(profile.id, id));
    if (response.isSuccess) {
      setQuestions(response.data);
    } else {
      // history.push("/student/assessments");
    }
  };
  const time = new Date();
  time.setSeconds(time.getSeconds() + 600);

  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    if (props.location.state?.subject) {
      fetch(props.location.state.subject);
    } else {
      history.push("/student/assessments");
    }
  }, [props.location.state]);
  const filterData = (e, index) => {
    const check = arr;
    check[index] = "";
    setArr(check);
  };
  const pushData = (e, index) => {
    const check = arr;
    check[index] = e;
    setArr(check);
  };

  const [answers, setAnswers] = useState([]);
  return (
    <div>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Submit Test</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to submit the test.</p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => window.location.reload()}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      {!agree ? (
        <StartExam
          start={agree}
          setStart={confirm}
          count={10}
          totalMarks={10}
        />
      ) : questions ? (
        <div className="assessment" style={{ background: "#eef2f7", minHeight: "100vh", padding: "24px 16px" }}>
          <div style={{ maxWidth: 820, margin: "0 auto" }}>
            {/* Header bar: title + live timer */}
            <div
              style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                gap: 12, flexWrap: "wrap",
                background: "#14274e", color: "#fff",
                padding: "14px 20px", borderRadius: "10px 10px 0 0",
              }}
            >
              <div>
                <div style={{ fontWeight: 700, fontSize: 17, letterSpacing: 0.3 }}>Assessment Test</div>
                <div style={{ fontSize: 12, opacity: 0.8 }}>Question {activePage} of 10</div>
              </div>
              <div
                style={{
                  background: "#fff", color: "#14274e", fontWeight: 700,
                  padding: "6px 14px", borderRadius: 20, fontSize: 15,
                  display: "flex", alignItems: "center", gap: 6,
                }}
              >
                <span role="img" aria-label="timer">⏱</span>
                <MyTimer expiryTimestamp={time} reloadTime={time * 1000} />
              </div>
            </div>

            {/* Progress bar */}
            <div style={{ height: 6, background: "#dde3ec" }}>
              <div style={{ height: "100%", width: `${(activePage / 10) * 100}%`, background: "#2e7d32", transition: "width .3s" }} />
            </div>

            {/* Question card */}
            <div style={{ background: "#fff", padding: "26px 24px", borderRadius: "0 0 10px 10px", boxShadow: "0 6px 20px rgba(20,39,78,.08)" }}>
              <div style={{ display: "flex", gap: 12, marginBottom: 20 }}>
                <span
                  style={{
                    flex: "0 0 32px", width: 32, height: 32, borderRadius: "50%",
                    background: "#14274e", color: "#fff", display: "flex",
                    alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 14,
                  }}
                >
                  {activePage}
                </span>
                <h3 style={{ fontSize: 18, lineHeight: 1.45, margin: 0, fontWeight: 600, color: "#1a1a1a" }}>
                  {questions[activePage - 1]?.questions.question}
                </h3>
              </div>

              <div style={{ paddingLeft: 44 }}>
                {questions[activePage - 1]?.questions.mcq.map((mcq, oi) => {
                  const selected = arr[activePage - 1] == mcq.id;
                  return (
                    <label
                      key={mcq.id}
                      style={{
                        display: "flex", alignItems: "center", gap: 12,
                        padding: "13px 16px", marginBottom: 11, borderRadius: 8,
                        cursor: "pointer", fontSize: 15,
                        border: "1.5px solid " + (selected ? "#14274e" : "#d8dee9"),
                        background: selected ? "#eef2fb" : "#fff",
                        transition: "all .15s",
                      }}
                    >
                      <input
                        type="radio"
                        name="ans"
                        value={mcq.id}
                        onChange={(e) => {
                          pushData(e.target.value, activePage - 1);
                          setAnswerid(e.target.value);
                        }}
                        checked={selected ? true : false}
                        style={{ width: 17, height: 17, accentColor: "#14274e" }}
                      />
                      <span
                        style={{
                          flex: "0 0 26px", width: 26, height: 26, borderRadius: "50%",
                          background: selected ? "#14274e" : "#eef2f7",
                          color: selected ? "#fff" : "#55607a",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontWeight: 700, fontSize: 13,
                        }}
                      >
                        {String.fromCharCode(65 + oi)}
                      </span>
                      <span>{mcq.answer}</span>
                    </label>
                  );
                })}
              </div>

              {/* Primary action */}
              <div style={{ marginTop: 22, paddingLeft: 44 }}>
                <button
                  className="btn"
                  type="submit"
                  style={{
                    background: "#14274e", color: "#fff", fontWeight: 600,
                    padding: "10px 26px", borderRadius: 8, border: "none",
                  }}
                  onClick={async () => {
                    const response = await dispatch(
                      submitAnswer(
                        questions[activePage - 1].question_list_id,
                        answerId,
                        profile.id
                      )
                    );
                    if (activePage < 10) {
                      setActivePage(activePage + 1);
                      setAnswerid("");
                    } else {
                      if (response) {
                        setShow(true);
                      }
                    }
                  }}
                >
                  {activePage < 10 ? "Next Question →" : "Submit Test"}
                </button>
              </div>
            </div>

            {/* Footer: pagination + finish */}
            <div
              style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                gap: 12, flexWrap: "wrap", marginTop: 18,
              }}
            >
              <ReactPaginate
                className="pagination mb-0"
                previousClassName="page-item"
                nextClassName="page-item"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                nextLinkClassName="page-link"
                previousLinkClassName="page-link"
                activeClassName="active"
                onPageChange={(e) => setActivePage(e.selected + 1)}
                pageCount={10}
                forcePage={activePage - 1}
              />
              <button
                className="btn"
                style={{ background: "#2e7d32", color: "#fff", fontWeight: 600, padding: "9px 22px", borderRadius: 8, border: "none" }}
                onClick={() => setShow(true)}
              >
                Finish Test
              </button>
            </div>
          </div>
        </div>
      ) : (
        <Spinner animation="border" role="status" size="lg">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      )}
    </div>
  );
};

export default Assessment;
